import { Box } from "@chakra-ui/react";

import { colors } from "../styles";
import { customEvent } from "../utils/customEvent";
import { getCdnImageSrc } from "../utils/getCdnImageSrc";
import { GoiLogo } from "./Icons/GoiLogo";
import {
  GOI_AUDIT_REPORT_URL,
  GOI_COMPANY_ADDRESS,
} from "../constants/companyAddress";
import { HLine } from "./Line";
import { HStack } from "./HStack";
import { Image } from "./Image";
import { NextLink } from "./NextLink";
import { Spacing } from "./Spacing";
import { VStack } from "./VStack";

interface RenewalFooterProps {
  onNoticeClick?: () => void;
}

export function RenewalFooter({ onNoticeClick }: RenewalFooterProps) {
  return (
    <VStack
      width="100%"
      padding="56px 24px 84px"
      alignItems="center"
      className="caption1 white"
    >
      <VStack width="100%" gap="24px">
        <VStack gap="24px">
          <GoiLogo color={colors.black} size={40} />
          <VStack className="body_14_r gray800" gap="6px">
            {onNoticeClick && <div onClick={onNoticeClick}>공지사항</div>}
            <a
              href="https://goifuneral.notion.site/22e2ed3aa6c54e04822d9669c572c0a1"
              target="_blank"
            >
              이용약관
            </a>
            <a
              className="subtitle_14_sb gray800"
              href="https://goifuneral.notion.site/544becd151c946618d151bd9b2659414"
              target="_blank"
            >
              개인정보처리방침
            </a>
            <a
              href={GOI_AUDIT_REPORT_URL}
              onClick={() => {
                customEvent({
                  newGtm: { path: "footer", trigger_and_target: "report" },
                });
              }}
              target="_blank"
            >
              감사보고서
            </a>

            <a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=8318701971">
              사업자정보확인
            </a>
            <NextLink
              href="https://www.goifuneral.co.kr/my/"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "footer",
                    trigger_and_target: "mypage-uv_my",
                  },
                });
              }}
            >
              마이페이지
            </NextLink>
            <NextLink
              href="https://www.goifuneral.co.kr/my/"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "footer",
                    trigger_and_target: "cs_center-uv_my",
                  },
                });
              }}
            >
              고객센터
            </NextLink>
            <NextLink
              href="https://www.goifuneral.co.kr/consultant/search/"
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "footer",
                    trigger_and_target: "footer-uv_consultant-search",
                  },
                });
              }}
            >
              상담사 조회
            </NextLink>
          </VStack>
        </VStack>

        <div className="gray500 caption_12_r">
          <div>{"(주) 고이장례연구소"}</div>
          <div>
            <div>대표이사 : 송슬옹 | 개인정보관리책임자 : 김소현</div>
          </div>
          <div> 주소 : {GOI_COMPANY_ADDRESS} | 전화 문의: 1666-9784</div>

          <div> 이메일 : contact@goifuneral.co.kr</div>
          <div>사업자 등록번호 : 831-87-01971</div>
          <div>통신판매업신고번호 : 2021-서울관악-2417</div>
        </div>
      </VStack>
      <Spacing gap={24} />
      <HLine height="1px" color={colors.gray100} />

      <Spacing gap={24} />
      <VStack width="100%" gap={16}>
        <Box className="caption_12_r gray600">
          © {new Date().getFullYear()}. (주)고이장례연구소 ALL RIGHTS RESERVED.
        </Box>

        <HStack alignItems="center" gap="12px">
          <NextLink
            href="https://www.instagram.com/goi.funeral/"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "instagram_icon-instagram",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/instagram.png")}
              width={24}
              height={24}
              alt="instagram"
            />
          </NextLink>
          <NextLink
            href="https://www.youtube.com/c/고이TV알기쉬운장례정보"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "youtube_icon-youtube",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/youtube.png")}
              width={24}
              height={24}
              alt="youtube"
            />
          </NextLink>

          <NextLink
            href="https://blog.naver.com/PostList.naver?blogId=goifuneral"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "footer",
                  trigger_and_target: "blog_icon-blog",
                },
              });
            }}
          >
            <Image
              src={getCdnImageSrc("platform/home/blog.png")}
              width={24}
              height={24}
              alt="blog"
            />
          </NextLink>
        </HStack>
      </VStack>
    </VStack>
  );
}
